import React from 'react'
import styled from 'styled-components'
import { Box } from '@rebass/grid'

const StyledBadge = styled(Box)`
  -webkit-appearance: none;
  display: inline-block;
  vertical-align: middle;
  padding: 0.25rem 0.75rem;
  font-weight: 600;
  font-size: 0.85rem;
  border-radius: 100px;
  background: ${(props) =>
    props.colorscheme === 'green'
      ? 'rgba(119, 202, 52, .07)'
      : props.colorscheme === 'yellow'
        ? 'rgba(253, 174, 56, .07)'
        : props.colorscheme === 'orange'
          ? 'rgba(253, 118, 56, .07)'
          : props.colorscheme === 'red'
            ? 'rgba(255, 118, 117, .07)'
            : props.colorscheme === 'purple'
              ? 'rgba(114, 73, 232, .07)'
              : props.colorscheme === 'white'
                ? 'rgba(255, 255, 255, 1)'
                : 'rgba(1, 122, 255, .07)'};
  color: ${(props) =>
    props.colorscheme === 'green'
      ? '#77CA34'
      : props.colorscheme === 'yellow'
        ? '#FDAE38'
        : props.colorscheme === 'orange'
          ? '#FD7638'
          : props.colorscheme === 'red'
            ? '#FF7675'
            : props.colorscheme === 'purple'
              ? '#7249E8'
              : props.colorscheme === 'white'
                ? '#31383c'
                : '#16A5F3'};
  box-shadow: ${(props) =>
    props.colorscheme === 'white'
      ? '0 0 0 1px rgba(0, 0, 0, 0.06), 0 1px 1px 0 rgba(0, 0, 0, 0.04)'
      : 'none'};
  border-radius: ${(props) =>
    props.colorscheme === 'white' ? '16px' : '100px'};
  height: ${(props) => (props.colorscheme === 'white' ? '24px' : 'auto')};
  line-height: ${(props) =>
    props.colorscheme === 'white' ? '24px' : 'normal'};
  padding: ${(props) =>
    props.colorscheme === 'white' ? '0 12px' : '0.25rem 0.75rem'};
  white-space: nowrap;
  transition: box-shadow 0.15s ease-in-out;
  cursor: ${(props) => (props.clickable === 'true' ? 'pointer' : 'default')};

  &:hover {
    box-shadow: ${(props) =>
      props.clickable === 'true' && props.colorscheme === 'white'
        ? '0 0 0 1px rgba(0, 0, 0, 0.08), 0 2px 4px 0 rgba(0, 0, 0, 0.08)'
        : props.colorscheme === 'white'
          ? '0 0 0 1px rgba(0, 0, 0, 0.06), 0 1px 1px 0 rgba(0, 0, 0, 0.04)'
          : 'none'};
  }
`

const Badge = (props) => {
  return <StyledBadge {...props}>{props.children}</StyledBadge>
}

export default Badge
